module.exports = __webpack_public_path__ + "img/sb01-02.076a86ae.png";